<template>
  <el-dialog
    title="修改简历"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="年龄" prop="age">
          <el-input v-model="form.age" placeholder="请输入年龄" class="max-w460"></el-input>
        </el-form-item>
        
        <el-form-item label="工作经验" prop="work_exp">
          <el-input 
            type="textarea"
            v-model="form.work_exp" 
            placeholder="请输入工作经验" 
            class="max-w460"
            :rows="3"  
            resize="none"  
          ></el-input>
        </el-form-item>
        
        <el-form-item label="学历" prop="degree">
          <el-input v-model="form.degree" placeholder="请输入学历" class="max-w460"></el-input>
        </el-form-item>
        
        <el-form-item label="入职状态" prop="working_status">
          <el-select v-model="form.working_status" placeholder="请选择入职状态" class="max-w460">
            <el-option label="未入职" :value="0"></el-option>
            <el-option label="已入职" :value="1"></el-option>
          </el-select>
        </el-form-item>

         <el-form-item label="虚拟被雇佣次数" prop="xn_apply">
          <el-input 
            v-model="form.xn_apply" 
            placeholder="请输入虚拟被雇佣次数" 
            class="max-w460"
          />
        </el-form-item>

        
        <el-form-item label="期望薪资" prop="expect_salary">
          <el-input 
            v-model="form.expect_salary" 
            type="number" 
            placeholder="请输入期望薪资" 
            class="max-w460"
            :step="0.01"
            :precision="2"
          >
            <template #append>元</template>
          </el-input>
        </el-form-item>

        <el-form-item label="期望城市" prop="expect_city">
          <el-input v-model="form.expect_city" placeholder="请输入期望城市" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="岗位经验" prop="job_info_exp">
          <el-input 
            type="textarea"
            v-model="form.job_info_exp" 
            placeholder="请输入岗位经验" 
            class="max-w460"
            :rows="3"  
            resize="none"  
          ></el-input>
        </el-form-item>

        <el-form-item label="工作经历" prop="work_history">
          <el-input 
            type="textarea"
            v-model="form.work_history" 
            placeholder="请输入工作经历" 
            class="max-w460"
            :rows="3"  
            resize="none"  
          ></el-input>
        </el-form-item>

        <el-form-item label="入学经历" prop="school_history">
          <el-input 
            type="textarea"
            v-model="form.school_history" 
            placeholder="请输入入学经历" 
            class="max-w460"
            :rows="3"  
            resize="none"  
          ></el-input>
        </el-form-item> 

        <!-- 新增资质证书上传区域 -->
        <el-form-item label="资质证书">
          <div class="qualifications-container">
            <!-- 已上传的资质证书 -->
            <div class="qualification-item" v-for="(item, index) in form.qualifications" :key="index">
              <img :src="item" class="qualification-img" @click="previewQualification(index)">
              <i class="el-icon-delete delete-icon" @click="removeQualification(index)"></i>
            </div>
            
            <!-- 上传按钮 -->
            <div class="upload-btn" @click="openQualificationUpload">
              <i class="el-icon-plus"></i>
              <span>上传资质证书</span>
            </div>
          </div>
          <div class="upload-tip">支持JPG、PNG格式，单张图片不超过5MB</div>
        </el-form-item>

        <!-- Word/PDF简历 -->
          <el-form-item label="Word简历">

            <div class="resume-file-container">

              <div
                class="resume-file-item"
                v-for="(item,index) in form.resumefile"
                :key="index"
              >

                <!-- 文件点击预览 -->
                <div
                  class="resume-file-left"
                  @click="openResumeFile(item)"
                >

                  <i class="el-icon-document"></i>

                  <span class="resume-file-name">
                    {{ getFileName(item) }}
                  </span>

                </div>

                <!-- 删除 -->
                <i
                  class="el-icon-delete delete-file-icon"
                  @click="removeResumeFile(index)"
                ></i>

              </div>

              <div
                class="empty-file"
                v-if="!form.resumefile || form.resumefile.length === 0"
              >
                暂无简历文件
              </div>

            </div>

          </el-form-item>

        <el-form-item label="排序" prop="name">
          <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>
       
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
      <!-- 图片上传组件 -->
      <Upload 
        v-if="isProductUpload" 
        :config="{ total: 9 }" 
        :isupload="isProductUpload" 
        @returnImgs="returnQualificationImgs"
      >上传图片</Upload>
    </div>
  </el-dialog>
</template>

<script>
import ResumeApi from '@/api/resume.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    draggable,
    Uediter
  },
  data() {
    return {
      isupload: false,
      isImg: false,  
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      form: {
        age: '',
        user_id: '',
        job_info_id: '',
        school_id: '',
        work_exp: '',
        degree: '',
        working_status: '',
        xn_apply: 0,
        expect_city: '',
        school_history: '',
        work_history: '',
        job_info_exp: '',
        expect_salary: '',
        name: '',
        code: 'custom',
        image: [],
        sort: 50,
        intro: "",
        bannar: [],
        qualifications: [] // 新增资质证书数组
      },
      loading: false,
      rules: {
        // name: [{ required: true, message: '请输入简历名称', trigger: 'blur' }],
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add", "resume_id"],
  methods: {
    // 获取简历详情
    getDetail() {
      let self = this;
      ResumeApi.detail({resume_id: self.resume_id}, true).then(res => {
        if (res.code === 1) {
          self.form = res.data;
          // 处理资质证书字段，将字符串转为数组
          self.form.qualifications = res.data.qualifications ? 
            res.data.qualifications.split(',') : 
            [];
            // Word/PDF简历
          self.form.resumefile = JSON.parse(res.data.resumefile)

          self.ueditor.text = self.form.intro;
          self.isImg = true;
          
          if(!self.form.bannar) {
            self.form.bannar = [];
          }
          if(!self.form.image) {
            self.form.image = [];
          }
        }
      }).catch(error => {});
    },

    // 预览资质证书
    previewQualification(index) {
      this.$viewerApi({
        images: this.form.qualifications,
        options: {
          initialViewIndex: index
        }
      });
    },

    // 移除资质证书
    removeQualification(index) {
      this.$confirm('确定要删除这张资质证书吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form.qualifications.splice(index, 1);
      }).catch(() => {});
    },
    // 打开简历文件
    openResumeFile(url) {

      window.open(url.url);

    },
        // 删除简历文件
    removeResumeFile(index) {

      this.$confirm('确定删除该简历文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.form.resumefile.splice(index, 1);

      }).catch(() => {});

    },
    // 获取文件名
    getFileName(url) {

      if (!url) return '';

      return url.name;

    },
    // 打开资质证书上传
    openQualificationUpload() {
      this.isProductUpload = true;
      this.code = "qualifications";
    },

    // 处理上传的资质证书
    returnQualificationImgs(e) {
      if (e != null) {
        // 验证图片格式
        const imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        
        e.forEach((element) => {
          const data_array = element.file_path.split(".");
          const ext = data_array[data_array.length - 1].toLowerCase();
          
          // 检查文件大小 (假设element中有size属性，单位字节)
          if (element.size && element.size > 5 * 1024 * 1024) {
            this.$message.error(`${element.file_name}超过5MB限制`);
            return;
          }
          
          if (!imgExpt.includes(ext)) {
            this.$message.error(`${element.file_name}格式不支持`);
            return;
          }
          
          prevent = true;
        });

        if (!prevent) {
          this.$message.error("请上传正确的图片格式");
          return false;
        }

        // 添加到资质证书列表
        const newQualifications = e.map(item => item.file_path);
        this.form.qualifications = [...this.form.qualifications, ...newQualifications];
      }
      this.isProductUpload = false;
    },

    // 提交表单
    onSubmit() {
      let self = this;
      let form = {
        ...self.form,
        resume_id: self.resume_id,
        // 将资质证书数组转为逗号分隔的字符串
        qualifications: self.form.qualifications.join(','),
        resumefile: self.form.resumefile.join(',')
      };
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ResumeApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
              self.$emit("refresh"); // 通知父组件刷新数据
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    // 其他原有方法保持不变
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    openUpload(e) {
      this.isupload = true;
    },
    returnImgsFunc(e) {
      // 原有图片上传逻辑
    },
    openProductUpload(code) {
      this.isProductUpload = true;
      this.code = code;
    },
    returnProductImgsFunc(e) {
      // 原有产品图片上传逻辑
    },
    deleteImg(index, code) {
      // 原有删除图片逻辑
    }
  }
};
</script>

<style>
/* 新增资质证书样式 */
.qualifications-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.qualification-item {
  position: relative;
  width: 120px;
  height: 120px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
}

.qualification-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.delete-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
  font-size: 14px;
}

.upload-btn {
  width: 120px;
  height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  color: #606266;
  background-color: #f5f7fa;
}

.upload-btn:hover {
  border-color: #409eff;
  color: #409eff;
}

.upload-btn i {
  font-size: 24px;
  margin-bottom: 5px;
}

.upload-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

/* 原有样式保持不变 */
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.max-w460 {
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}

.resume-file-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.resume-file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 15px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #f9fafc;
}

.resume-file-left {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1;
  overflow: hidden;
}

.resume-file-left i {
  font-size: 18px;
  color: #409eff;
}

.resume-file-name {
  margin-left: 10px;
  color: #333;
  font-size: 14px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.delete-file-icon {
  color: #f56c6c;
  cursor: pointer;
  font-size: 16px;
}

.empty-file {
  color: #999;
  font-size: 13px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/resume/index/part/edit.vue